import { useEffect, useRef } from 'react';
import { useFastJoinMedia } from 'features/join/fast-join/useFastJoinMedia';
import FastJoinPublisherLayout from 'features/join/fast-join/FastJoinPublisherLayout';

const FastJoinPublisher = () => {
  const didInitRef = useRef(false);

  const { requestPermissions, state, joinWithoutMedia, reload } = useFastJoinMedia();

  useEffect(() => {
    if (!didInitRef.current) {
      didInitRef.current = true;
      requestPermissions();
    }

    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <FastJoinPublisherLayout
      status={state.status}
      onReload={reload}
      onJoinWithoutMedia={joinWithoutMedia}
    />
  );
};

export default FastJoinPublisher;
